export default __webpack_public_path__ + "static/media/article16.0617e916.md";